<template lang="pug">

  transition(name="datepicker")
    .p-datepicker(
      v-click-outside="fecharSeletorData"
      :class="{ 'p-datepicker--com-erro': !!error, 'p-datepicker--com-info': !!mensagemDeInformacao }"
    )
      p-text-field.p-datepicker__textfield(
        v-if="usaMascaraNoInput"
        v-model="dataRenderizadaNoInput",
        :label="labelResolvida",
        :tamanho="tamanho || undefined",
        :name="name",
        type="text",
        autocomplete="off",
        :required="$attrs.hasOwnProperty('required')",
        :loading="loading",
        :disabled="disabled",
        v-mask="mascaraDoInput",
        :error="error"
        :sinalizarErroSemMensagem="sinalizarErroSemMensagem"
        :readonly="inputDesabilitadoParaDigitacao"
        :mensagemDeInformacao="mensagemDeInformacao"
      )
        template(#logoIcon)
          slot(name="logoIcon")

        template(#icon)
          PontotelBotaoIcone(
            :tamanho="buttonSize"
            tipo="neutro"
            @clique="abrirSeletorData"
            :desabilitado="disabled || null"
            :title="$t('compartilhados.date.PDatePicker.mostrarCalendario')"
          )
            template(v-slot:icone)
              IconeSVG(icone="calendario" cor="var(--acao-primaria)" width="16px" height="16px" aria-hidden="true")

      p-text-field.p-datepicker__textfield(
        v-else
        v-model="dataRenderizadaNoInput",
        :label="labelResolvida",
        :tamanho="tamanho || undefined",
        :name="name",
        type="text",
        autocomplete="off",
        :required="$attrs.hasOwnProperty('required')",
        :loading="loading",
        :disabled="disabled",
        :error="error"
        :sinalizarErroSemMensagem="sinalizarErroSemMensagem"
        :readonly="inputDesabilitadoParaDigitacao"
        :mensagemDeInformacao="mensagemDeInformacao"
      )
        template(#logoIcon)
          slot(name="logoIcon")

        template(#icon)
          PontotelBotaoIcone(
            :tamanho="buttonSize"
            tipo="neutro"
            @clique="abrirSeletorData"
            :desabilitado="disabled || null"
            :title="$t('compartilhados.date.PDatePicker.mostrarCalendario')"
          )
            template(v-slot:icone)
              IconeSVG(icone="calendario" cor="var(--acao-primaria)" width="16px" height="16px" aria-hidden="true")

      transition(name="bounce")
        .p-datepicker__seletor(
          v-if="mostrarSeletorDeData"
          ref="seletorDeData"
          :style="posicaoSeletorDeData"
        )
          VueDatePicker(
            :model-value="valorDataNoCalendario"
            @update:model-value="aoAtualizarCalendario"
            :locale="configuracaoLocale.localeCode"
            :format-locale="configuracaoLocale.locale"
            :day-names="configuracaoLocale.weekdaysMin"
            :enable-time-picker="false"
            :range="configuracaoRange"
            :min-date="minDate"
            :max-date="maxDate"
            :month-picker="ehSeletorDeMes"
            :month-name-format="'short'"
            :week-start="0"
            auto-apply
            inline
            hide-input-icon
          )
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import PTextField from 'src/common/inputs/PTextField.vue'
import IconeSVG from 'src/common/IconeSVG.vue'

import moment from 'moment'

import { handlerUseStateVmodel } from '../mixins/handlerUseStateVmodel'
import { mask } from 'src/common/mask'
import {
  fromMonthPickerModel,
  getDatepickerLocaleConfig,
  isMonthPickerValueType,
  normalizeDateValue,
  toMonthPickerModel
} from './datepickerAdapter'

export default {
  name: 'PDatePicker',
  mixins: [handlerUseStateVmodel()],
  emits: ['update:modelValue', 'change', 'abreDataPicker'],
  directives: { mask },
  components: {
    PTextField,
    IconeSVG,
    VueDatePicker
  },
  props: {
    name: { type: String, required: true },
    format: { type: String, 'default': 'DD/MM/YYYY' },
    loading: Boolean,
    disabled: Boolean,
    label: String,
    title: String,
    error: String,
    sinalizarErroSemMensagem: { type: Boolean, required: false, default: false },
    range: { type: Boolean, default: false },
    minDate: {type: Date},
    maxDate: {type: Date},
    buttonSize: {type: String, default: 'P'},
    tamanho: {type: String, default: null},
    tipoDoSeletor: {type: String, default: 'date'},
    mensagemDeInformacao: { type: String, default: '' },
    mascaraDoInput: { type: String, default: '##/##/####' },
  },
  watch: {
    state () {
      this.definirInputPeloModoDeVisualizacao()
    }
  },
  data () {
    return {
      mostrarSeletorDeData: false,
      valorDoInput: '',
      atualizandoInputInternamente: false,
      posicaoSeletorDeData: {
        visibility: 'hidden'
      }
    }
  },
  mounted () {
    this.definirInputPeloModoDeVisualizacao()
  },
  beforeUnmount () {
    this.removerOuvintesDePosicionamento()
  },
  methods: {
    abrirSeletorData () {
      this.mostrarSeletorDeData = !this.mostrarSeletorDeData

      if (this.mostrarSeletorDeData) {
        this.$nextTick(() => {
          this.atualizarPosicaoSeletorData()
          this.adicionarOuvintesDePosicionamento()
        })
      } else {
        this.removerOuvintesDePosicionamento()
      }

      this.$emit('abreDataPicker')
    },
    fecharSeletorData () {
      this.mostrarSeletorDeData = false
      this.removerOuvintesDePosicionamento()
    },
    adicionarOuvintesDePosicionamento () {
      this.removerOuvintesDePosicionamento()
      window.addEventListener('resize', this.atualizarPosicaoSeletorData)
      window.addEventListener('scroll', this.atualizarPosicaoSeletorData, true)
    },
    removerOuvintesDePosicionamento () {
      window.removeEventListener('resize', this.atualizarPosicaoSeletorData)
      window.removeEventListener('scroll', this.atualizarPosicaoSeletorData, true)
    },
    atualizarPosicaoSeletorData () {
      const seletorDeData = this.$refs.seletorDeData

      if (!this.mostrarSeletorDeData || !seletorDeData) return

      const ancora = this.$el.getBoundingClientRect()
      const popup = seletorDeData.getBoundingClientRect()
      const espacamento = Number.parseFloat(
        window.getComputedStyle(this.$el).getPropertyValue('--espacamento-8')
      ) || 0
      const larguraViewport = document.documentElement.clientWidth
      const alturaViewport = document.documentElement.clientHeight
      const limiteHorizontal = Math.max(
        espacamento,
        larguraViewport - popup.width - espacamento
      )
      const esquerda = Math.min(
        Math.max(ancora.left, espacamento),
        limiteHorizontal
      )
      const cabeAbaixo = alturaViewport - ancora.bottom >= popup.height + espacamento
      const cabeAcima = ancora.top >= popup.height + espacamento
      const abrirAcima = !cabeAbaixo && cabeAcima
      const topoDesejado = abrirAcima
        ? ancora.top - popup.height - espacamento
        : ancora.bottom + espacamento
      const limiteVertical = Math.max(
        espacamento,
        alturaViewport - popup.height - espacamento
      )
      const topo = Math.min(
        Math.max(topoDesejado, espacamento),
        limiteVertical
      )

      this.posicaoSeletorDeData = {
        top: `${topo}px`,
        left: `${esquerda}px`,
        visibility: 'visible'
      }
    },
    formatarDataComIntervaloParaInput (start, end) {
      this.atualizandoInputInternamente = true

      if (!start || !end) {
        this.valorDoInput = ''
        this.$nextTick(() => {
          this.atualizandoInputInternamente = false
        })
        return
      }

      const dataInicialFormatada = moment(start).format(this.format)
      const dataFinalFormatada = moment(end).format(this.format)
      this.valorDoInput = `${dataInicialFormatada} - ${dataFinalFormatada}`
      this.$nextTick(() => {
        this.atualizandoInputInternamente = false
      })
    },
    definirInputPeloModoDeVisualizacao () {
      this.atualizandoInputInternamente = true

      if (this.modoVisualizacao === 'unica') {
        this.valorDoInput = moment(this.state)

        if (!this.valorDoInput.isValid()) {
          this.valorDoInput = ''
        } else {
          this.valorDoInput = this.valorDoInput.format(this.format)
        }
      } else if (this.modoVisualizacao === 'intervalo') {
        const dataFormatada = this.formatarDatasParaComponente(this.valorDataFormatada)

        if (!dataFormatada?.start || !dataFormatada?.end) {
          this.valorDoInput = ''
          this.$nextTick(() => {
            this.atualizandoInputInternamente = false
          })
          return
        }

        this.formatarDataComIntervaloParaInput(dataFormatada.start, dataFormatada.end)
        return
      }

      this.$nextTick(() => {
        this.atualizandoInputInternamente = false
      })
    },
    formatarDatasParaComponente (value) {
      if (Array.isArray(value)) {
        return {
          start: value[0],
          end: value[1]
        }
      } else {
        return value
      }
    },
    normalizarValorDeData (value) {
      if (this.ehSeletorDeMes) {
        return fromMonthPickerModel(value)
      }

      return normalizeDateValue(value)
    },
    aoAtualizarCalendario (value) {
      if (this.modoVisualizacao === 'intervalo') {
        if (!Array.isArray(value) || value.length < 2 || !value[0] || !value[1]) return

        const [startDate, endDate] = value.map(date => normalizeDateValue(date))

        if (!startDate || !endDate) return

        this.state = {
          start: startDate,
          end: endDate
        }
        this.formatarDataComIntervaloParaInput(startDate, endDate)
        this.fecharSeletorData()
        return
      }

      const dataNormalizada = this.normalizarValorDeData(value)

      if (!dataNormalizada) return

      this.state = dataNormalizada
      this.definirInputPeloModoDeVisualizacao()
      this.fecharSeletorData()
    }
  },
  computed: {
    labelResolvida () {
      return this.label || this.title || ' '
    },
    dataRenderizadaNoInput: {
      get () { return this.valorDoInput },
      set (value) {
        if (this.atualizandoInputInternamente) {
          this.valorDoInput = value
          return
        }

        if (this.modoVisualizacao === 'unica') {
          if (value === '') {
            this.valorDoInput = ''
            this.state = null
            return
          }

          const dataDigitada = moment(value, this.format, true)

          if (dataDigitada.isValid()) {
            this.state = dataDigitada.toDate()
            this.definirInputPeloModoDeVisualizacao()
          }
        }
      }
    },
    valorDataFormatada () {
      if (this.modoVisualizacao === 'intervalo') {
        return [this.state?.start, this.state?.end]
      }

      return this.state
    },
    valorDataNoCalendario () {
      if (this.modoVisualizacao === 'intervalo') {
        if (!this.state?.start || !this.state?.end) return null
        return [this.state.start, this.state.end]
      }

      if (this.ehSeletorDeMes) {
        return toMonthPickerModel(this.state)
      }

      return this.state || null
    },
    modoVisualizacao () { return this.range ? 'intervalo' : 'unica' },
    usaMascaraNoInput () { return this.modoVisualizacao === 'unica' },
    inputDesabilitadoParaDigitacao () { return this.range },
    ehSeletorDeMes () {
      return isMonthPickerValueType(this.tipoDoSeletor)
    },
    configuracaoRange () {
      return this.range ? { partialRange: false } : false
    },
    configuracaoLocale () {
      const localeAtual = typeof this.$i18n.locale === 'string'
        ? this.$i18n.locale
        : this.$i18n.locale?.value
      const locale = getDatepickerLocaleConfig(localeAtual)

      return {
        ...locale,
        weekdaysMin: [
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Dom'),
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Seg'),
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Ter'),
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Qua'),
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Qui'),
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Sex'),
          this.$t('sheets.Timesheet.Header.DateSlider.configuracaoDatePicker.dias.Sab')
        ]
      }
    }
  }
}
</script>

<style lang='scss'>
.p-datepicker {
  display: block;
  width: 100%;
  position: relative;
}

.p-datepicker__textfield {
  width: 100%;
  min-width: 0;
}

.p-datepicker__textfield .p-textfield__icon--span {
  margin-left: 8px;
}

.p-datepicker:not(.p-datepicker--com-erro):not(.p-datepicker--com-info) .p-datepicker__textfield .error-msg {
  display: none;
}

.p-datepicker__seletor {
  position: fixed !important;
  z-index: 2000 !important;
}

.p-datepicker__seletor .dp__main {
  font-family: var(--texto-tipografia, "Hanken Grotesk", var(--front-font));
}

/* Popup mapeado aos tokens do DS (calendario.*) — acompanha o white-label Sankhya */
.p-datepicker__seletor .dp__theme_light {
  --dp-primary-color: var(--calendario-cor-background-clicado); /* dia selecionado: primária (Sankhya: verde) */
  --dp-primary-text-color: var(--calendario-cor-conteudo-clicado); /* texto do selecionado: preto (Sankhya: branco) */
  --dp-border-color: var(--borda);
  --dp-menu-border-color: var(--borda);
  --dp-hover-color: var(--calendario-cor-background-hover); /* hover de célula: tint da primária — corrige o hard-code rgba Sankhya */
  --dp-hover-text-color: var(--calendario-cor-conteudo-hover); /* texto no hover */
  --dp-disabled-color: var(--calendario-cor-conteudo-desabilitado); /* dia desabilitado */
  --dp-icon-color: var(--cor-secundaria-100); /* ícones de navegação: secundária (marca) */
  --dp-text-color: var(--calendario-cor-conteudo-default); /* dias: preto */
}

.p-datepicker__seletor .dp__calendar_header_item,
.p-datepicker__seletor .dp__month_year_select,
.p-datepicker__seletor .dp__overlay_cell,
.p-datepicker__seletor .dp__cell_inner,
.p-datepicker__seletor .dp__month_picker_header {
  font-family: var(--texto-tipografia, "Hanken Grotesk", var(--front-font));
}

.p-datepicker__seletor .dp__calendar_header_item {
  font-size: 14px;
  color: var(--color-primary);
}

.p-datepicker__seletor .dp__cell_inner,
.p-datepicker__seletor .dp__overlay_cell {
  font-size: 14px;
}

.p-datepicker__seletor .dp__active_date,
.p-datepicker__seletor .dp__range_start,
.p-datepicker__seletor .dp__range_end,
.p-datepicker__seletor .dp__overlay_cell_active {
  background-color: var(--calendario-cor-background-clicado);
  color: var(--calendario-cor-conteudo-clicado);
}

.p-datepicker__seletor .dp__today {
  border-color: var(--cor-secundaria-100); /* "hoje": borda secundária (marca; Sankhya: azul) */
}
</style>
